module.exports = __webpack_public_path__ + "img/pubpeer-search.9a61afb5.png";